import { RouteType } from "../types";
import { route } from "../utils";

import DeliveryFeePage from "@/pages/delivery-fee/delivery-fee-page";

export const deliveryFeeRoutes: Record<string, RouteType> = {
  list: route("/orders", DeliveryFeePage),
  new: route("/orders/new", DeliveryFeePage),
};
